import { combineReducers } from 'redux';

import { overviewReducer, DashboardOverviewState } from './overview';
import {
  pullRequestsReducer,
  DashboardPullRequestsState,
} from './pull-requests';
import {
  repositoriesReducer,
  DashboardRepositoriesState,
} from './repositories';
import {
  owners,
  projects,
  workspaces,
  OwnersFilterState,
  ProjectsFilterState,
  WorkspacesFilterState,
} from './repository-filters';

export type DashboardState = {
  pullRequests: DashboardPullRequestsState;
  repositories: DashboardRepositoriesState;
  repositoryFilters: {
    owners: OwnersFilterState;
    workspaces: WorkspacesFilterState;
    projects: ProjectsFilterState;
  };
  overviewRepositories: DashboardOverviewState;
};

export const dashboardReducer = combineReducers({
  pullRequests: pullRequestsReducer,
  repositories: repositoriesReducer,
  repositoryFilters: combineReducers({
    owners,
    projects,
    workspaces,
  }),
  overviewRepositories: overviewReducer,
});
